import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import authHeader from "../services/auth/auth-header";
import { toAbsoluteUrl } from "../services";
import { AuthLayout, Button } from "../components";
import UpgradeCard from "../components/upgradeCard/upgradeCard";
// get user data from state
const authData = (state) => state.auth;

export const PaymentConfirmation = (props) => {
  const [success, setSuccess] = useState("");
  const [type, setType] = useState(null);
  const [upgrade, setUpgrade] = useState(false);
  const data = useSelector(authData);

  let navigate = useNavigate();
  let updatePlan = () => {
    setUpgrade(!upgrade);
  };

  let onCloseUpgrade = () => {
    setUpgrade(!upgrade);
  };
  let verifyPayment = () => {
    let data = JSON.parse(sessionStorage.getItem("id"));
    let confirmPaymentApiCall = {
      // url: "http://192.168.1.118:3000/gcp/pay/confrim-session-status",
      // url: "https://stg2.backend.thetalent.games/gcp/pay/confrim-session-status",
      url: "https://backendpaygo.thetalent.games/gcp/pay/confrim-session-status",
      data: {
        sessionId: data,
      },
      config: {
        headers: authHeader(),
      },
    };

    if (data) {
      Axios.post(
        confirmPaymentApiCall.url,
        confirmPaymentApiCall.data,
        confirmPaymentApiCall.config
      )
        .then((res) => {
          let status = res.data && res.data.status;
          if (status) {
            setSuccess("200");
          } else {
            setSuccess("400");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    } else {
      // sessionStorage.clear();
      navigate("/", { replace: true });
    }
  };
  useEffect(() => {
    setType(data.userType);
    verifyPayment();
  }, []);

  return (
    <AuthLayout mx="12" bottom="-2.5rem" url="/media/login/plan_footer.png">
      <div className=" border-4 border-[#007E8B] 2xl:w-5/12 z-10 xl:w-5/12 lg:w-6/12 md:w-7/12 w-9/12  mt-24 bg-white drop-shadow-md rounded-lg  py-10   md:px-8 px-6">
        {success === "200" ? (
          <div>
            <p className="text-[#292929] font-semibold text-2xl text-center my-6">
              Congratulations! Payment Successful!
            </p>

            <div className="my-6 px-22">
              <p className="text-[#292929] text-lg text-center">
                Your Payment has been successful. Please use the same login
                details that you have received previously to access the new
                plan.
              </p>
            </div>

            <div className=" flex flex-col justify-center items-center">
              <Button
                type="button"
                customStyle="mx-auto mt-6 2xl:w-5/12 xl:w-5/12 lg:w-5/12 md:7/12 w-9/12"
                name="Access My Plan"
                onClick={() => {
                  sessionStorage.clear();
                  navigate("/", { replace: true });
                }}
              />
            </div>
          </div>
        ) : success === "400" ? (
          <div>
            <div>
              <p className="text-[#292929] font-semibold text-2xl text-center my-6">
                Payment Unsuccessful!
              </p>

              <div className="my-6 px-22">
                <p className="text-[#292929] text-lg text-center">
                  Your payment has failed. Do you want to try again?
                </p>
              </div>

              <div className=" flex  justify-center items-center">
                {type !== "premium" ? (
                  <Button
                    type="button"
                    customStyle="mx-auto mt-6 w-[40%]"
                    name="Yes"
                    onClick={() => {
                      updatePlan();
                    }}
                  />
                ) : (
                  <Button
                    type="button"
                    customStyle="mx-auto mt-6 w-[40%]"
                    name="Yes"
                    onClick={() => {
                      alert("");
                    }}
                  />
                )}

                <Button
                  type="button"
                  customStyle="mx-auto mt-6 w-[40%]"
                  name="No"
                  onClick={() => {
                    // navigate("/dashboard", { replace: true });
                    sessionStorage.clear();
                    navigate("/", { replace: true });
                  }}
                />
              </div>

              <div className="my-6 px-22">
                <p className="text-[#292929] text-lg text-center">
                  Note: Upon choosing ‘NO’ you will be redirected to your
                  earlier plan.
                </p>
              </div>
            </div>

            {upgrade ? (
              <UpgradeCard
                type={type.toUpperCase()}
                onCloseUpgrade={onCloseUpgrade}
              />
            ) : null}
          </div>
        ) : (
          <div className="flex justify-center items-center my-[2rem]">
            <img
              src={toAbsoluteUrl("/media/dashboard/logo.gif")}
              alt="TTG LOGO"
              style={{
                width: "100px",
                height: "90px",
              }}
            />
          </div>
        )}
      </div>
    </AuthLayout>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentConfirmation);
